import Service, { inject as service } from '@ember/service';

export default class ReportMailerService extends Service {
  @service fetch;

  sendReport(report) {
    return this.fetch.post(`reports/${report.id}/send_report`);
  }
}
